import { PREVIEW_MODE } from '$lib/global/constants';

export const appendDomainQueryParam = () => {
    if (!PREVIEW_MODE) {
        return '';
    }

    return `&domain=${window.location.host}`;
};
